export default __webpack_public_path__ + "static/remix-hover-light-38552b1d9f6a35b80a3ba3f04159b9d1c3fb6b559b6f9e32d35fe5561467d075.png";